export default "__VITE_ASSET__b80142d1__"